
module.exports = {
  bookmark: require('./paths/bookmark'),
  calendar: require('./paths/calendar'),
  camera: require('./paths/camera'),
  chat: require('./paths/chat'),
  check: require('./paths/check'),
  chevronDown: require('./paths/chevron-down'),
  chevronLeft: require('./paths/chevron-left'),
  chevronRight: require('./paths/chevron-right'),
  chevronUp: require('./paths/chevron-up'),
  clock: require('./paths/clock'),
  close: require('./paths/close'),
  cloud: require('./paths/cloud'),
  cog: require('./paths/cog'),
  compose: require('./paths/compose'),
  expand: require('./paths/expand'),
  external: require('./paths/external'),
  file: require('./paths/file'),
  folder: require('./paths/folder'),
  geolocation: require('./paths/geolocation'),
  grid: require('./paths/grid'),
  heart: require('./paths/heart'),
  home: require('./paths/home'),
  info: require('./paths/info'),
  link: require('./paths/link'),
  list: require('./paths/list'),
  lock: require('./paths/lock'),
  mail: require('./paths/mail'),
  musicNote: require('./paths/music-note'),
  next: require('./paths/next'),
  no: require('./paths/no'),
  pause: require('./paths/pause'),
  picture: require('./paths/picture'),
  pin: require('./paths/pin'),
  play: require('./paths/play'),
  previous: require('./paths/previous'),
  refresh: require('./paths/refresh'),
  repost: require('./paths/repost'),
  search: require('./paths/search'),
  shoppingCart: require('./paths/shopping-cart'),
  skull: require('./paths/skull'),
  speakerVolume: require('./paths/speaker-volume'),
  speaker: require('./paths/speaker'),
  star: require('./paths/star'),
  tag: require('./paths/tag'),
  trash: require('./paths/trash'),
  triangleDown: require('./paths/triangle-down'),
  triangleLeft: require('./paths/triangle-left'),
  triangleRight: require('./paths/triangle-right'),
  triangleUp: require('./paths/triangle-up'),
  user: require('./paths/user'),
  video: require('./paths/video'),
  warning: require('./paths/warning')
}




//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/geomicons-open/src/index.js
// module id = 308
// module chunks = 6